import Client from "./Clients/AxiosClient";
const resource = "/api/ReceiptDetail";

export default {
  getReceipts(lazyParams, searchFilterbyCategory,searchById,searchByString,outletId,isIth,isIpp) {
    return Client.get(
      `${resource}/${localStorage.getItem("staffPosition")}/${localStorage.getItem("userId")}/${searchFilterbyCategory}/${outletId}`,
      {
        params: {
          skipCount: lazyParams.first,
          takeCount: lazyParams.rows,
          searchById:searchById,
          searchByString: searchByString,
          isIth: isIth,
          isIpp: isIpp,
        },
      }
    );
  },
  getReceiptTrack(receiptCode) {
    return Client.get(`${resource}/ReceiptCodeTracking/${receiptCode}`);
  },
  create(receipt) {
    return Client.post(`${resource}`, receipt);
  },
  putCompletionImage(deviceId,completionImage){
    return Client.put(`${resource}/CompletionImage`,{deviceId:deviceId,completionImage:completionImage});
  },
  putPostageImage(deviceId,postageImage){
    return Client.put(`${resource}/PostageImage`,{deviceId:deviceId,postageImage:postageImage});
  },
  putDeviceIth(deviceId, isIth){
    return Client.put(`${resource}/DeviceIth`, { deviceId: deviceId, isIth: isIth });
  },
  putDeviceIpp(deviceId, isIpp){
    return Client.put(`${resource}/DeviceIpp`, { deviceId: deviceId, isIpp: isIpp });
  }
};
